import { defineStyle } from '@chakra-ui/react';

export const WizardStepStyles = defineStyle({});
